const calculationsToOffer = ({ id, ...data }) => ({
  method: "GET",
  url: `/calculations/${id}/convert2offer`,
  data,
});

const updateCalculation = ({ id, ...data }) => ({
  method: "PUT",
  url: `/calculations/${id}`,
  data,
});

const setCalculationSettings = (data) => ({
  method: "POST",
  url: `/calculation_settings`,
  data,
});

const getCalculationSettings = (data) => ({
  method: "GET",
  url: `/calculation_settings`,
  data,
});

const replaceCalculationSetting = ({ id, ...data }) => ({
  method: "PUT",
  url: `/calculation_settings/${id}`,
  data,
});

export const calculationsApi = {
  calculationsToOffer,
  updateCalculation,
  setCalculationSettings,
  getCalculationSettings,
  replaceCalculationSetting,
};
